import { openBlock as e, createElementBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, a = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M16.455 4.089A4.39 4.39 0 0 0 13.11 5.38a4.376 4.376 0 0 0-1.182 4.108c.14.582.034 1.283-.466 1.783l-7.063 7.063a.25.25 0 0 0 0 .353l1.414 1.414a.25.25 0 0 0 .354 0l7.063-7.063c.5-.5 1.2-.605 1.783-.466a4.376 4.376 0 0 0 4.107-1.181 4.391 4.391 0 0 0 1.292-3.347.2.2 0 0 0-.132.066l-2.236 2.235a1.75 1.75 0 0 1-2.474 0l-1.415-1.414a1.75 1.75 0 0 1 0-2.475l2.236-2.235a.2.2 0 0 0 .065-.132Zm1.447-.415a1.67 1.67 0 0 1-.452 1.607l-2.235 2.236a.25.25 0 0 0 0 .353l1.414 1.414a.25.25 0 0 0 .354 0l2.235-2.235a1.67 1.67 0 0 1 1.608-.451 1.452 1.452 0 0 1 1.082 1.35 5.89 5.89 0 0 1-1.728 4.503 5.876 5.876 0 0 1-5.517 1.58c-.185-.044-.315.01-.374.068l-7.063 7.063a1.75 1.75 0 0 1-2.474 0l-1.415-1.414a1.75 1.75 0 0 1 0-2.475L10.4 10.21c.059-.058.113-.189.068-.374a5.876 5.876 0 0 1 1.58-5.516 5.89 5.89 0 0 1 4.503-1.728 1.45 1.45 0 0 1 1.35 1.082Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  a
];
function n(r, d) {
  return e(), l("svg", t, [...c]);
}
const i = { render: n };
export {
  i as default,
  n as render
};
